import { Box, styled } from "@mui/material";

import LoadingIcon from "../assets/Icons/LoadingIcon";

const CustomContainer = styled(Box)`
  height: 57px;
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;
  transform-origin: 50% 50%;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
const Spinner = () => {
  return (
    <CustomContainer>
      <LoadingIcon />
    </CustomContainer>
  );
};

export default Spinner;
